module.exports = __webpack_public_path__ + "static/media/ICONS-FASHION_ACCESORIES.0c2e5e29.svg";